import { Component, Inject, OnInit } from '@angular/core';
import { DialogBoxDisplayModes, DialogBoxResults, IDialogBoxConfiguration } from '../../models/dialogDefaults';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
    get title(): string {
        return this.config.title;
    }

    get message(): string {
        return this.config.message;
    }

    get mode(): DialogBoxDisplayModes{
        return this.config.mode;
    }

    modeOkCancel = DialogBoxDisplayModes.OkCancel;
    modeOk = DialogBoxDisplayModes.Ok;
    modeYesNo = DialogBoxDisplayModes.YesNo;

    constructor(@Inject(MAT_DIALOG_DATA) private config: IDialogBoxConfiguration,
        private dialig: MatDialogRef<DialogComponent>) { }

    ngOnInit(): void {
    }

    completed(){
        if(this.mode === DialogBoxDisplayModes.Ok){
            this.dialig.close(DialogBoxResults.Ok);
        }else if(this.mode === DialogBoxDisplayModes.OkCancel){
            this.dialig.close(DialogBoxResults.Ok);
        }else{
            this.dialig.close(DialogBoxResults.Yes);
        }
    }

    cancelled(){
        if(this.mode === DialogBoxDisplayModes.Ok){
            //This shouldn't be possible as cancel button should hide
            this.dialig.close();
        }else if(this.mode === DialogBoxDisplayModes.OkCancel){
            this.dialig.close(DialogBoxResults.Cancel);
        }else{
            this.dialig.close(DialogBoxResults.No);
        }
    }
}
